import { render, staticRenderFns } from "./admin-root.vue?vue&type=template&id=ac8999a8"
import script from "./admin-root.vue?vue&type=script&lang=js"
export * from "./admin-root.vue?vue&type=script&lang=js"
import style0 from "./admin-root.vue?vue&type=style&index=0&id=ac8999a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports